import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import type { ReactNode } from "react";

export type BoardItem = { id: string; column: string; content: ReactNode };

/** Status columns of cards; dropping a card in another column calls onMove (same library as the deals board) */
export const StatusBoard = ({
  columns,
  items,
  onMove,
  disabled,
}: {
  columns: { id: string; label: ReactNode }[];
  items: BoardItem[];
  onMove: (itemId: string, columnId: string) => void;
  disabled?: boolean;
}) => (
  <DragDropContext
    onDragEnd={({ draggableId, source, destination }) => {
      if (destination && destination.droppableId !== source.droppableId) {
        onMove(draggableId, destination.droppableId);
      }
    }}
  >
    <div className="flex gap-4 overflow-x-auto pb-4">
      {columns.map((column) => (
        <div key={column.id} className="flex-1 min-w-48">
          <h3 className="text-base font-medium text-center">{column.label}</h3>
          <Droppable droppableId={column.id}>
            {(droppableProvided, snapshot) => (
              <div
                ref={droppableProvided.innerRef}
                {...droppableProvided.droppableProps}
                className={`flex flex-col rounded-2xl mt-2 gap-2 min-h-24 ${
                  snapshot.isDraggingOver ? "bg-muted" : ""
                }`}
              >
                {items
                  .filter((item) => item.column === column.id)
                  .map((item, index) => (
                    <Draggable
                      key={item.id}
                      draggableId={item.id}
                      index={index}
                      isDragDisabled={disabled}
                    >
                      {(provided, dragSnapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className={
                            dragSnapshot.isDragging ? "opacity-90 rotate-1" : ""
                          }
                        >
                          {item.content}
                        </div>
                      )}
                    </Draggable>
                  ))}
                {droppableProvided.placeholder}
              </div>
            )}
          </Droppable>
        </div>
      ))}
    </div>
  </DragDropContext>
);
